import { combineReducers } from "redux";
import {
  ActiveSorterSessionReducers,
  AddBoxTypeReducers,
  AddProductVolumeReducers,
  AssignBoxReducers,
  BoxCreateBulkReducers,
  BoxMoveReducers,
  BoxPDFBulkLabelReducers,
  BoxVolumeSettingReducers,
  CancelSessionReducers,
  CreatePlanReducers,
  CreateSessionReducers,
  deleteDockMapReducers,
  ForceCloseReducers,
  getActiveSessionReducers,
  getAssociatedDockSettingReducers,
  getBoxLableReducers,
  getBoxListReducers,
  getDockAssociatedBoxLabelReducers,
  getDockAssociatedBoxReducers,
  GetDockBySorterIdReducers,
  GetDockMappingSummaryReducers,
  getDockSettingReducers,
  GetDropdownListReducers,
  GetMapDockListReducers,
  GetRejectionDataReducers,
  getSessionDetailReducers,
  getSkuReducers,
  GetSkuWiseSortationPlanReducers,
  getSubLocationByInvoiceReducers,
  LoginReducers,
  MapDockReducers,
  printAssociatedBoxLabelReducers,
  RemoveSessionReducers,
  SaveAssociatedBoxSettingReducers,
  saveDockSettingReducers,
  saveGetInventoryIncomingReducers,
  sessionReducers,
} from "../Reducers/SorterReducers";

const rootReducer = combineReducers({
  Login: LoginReducers,
  GetDropdown: GetDropdownListReducers,
  DockMapSummary: GetDockMappingSummaryReducers,
  Map_Dock: MapDockReducers,
  DocksName: GetDockBySorterIdReducers,
  dock_setting: getDockSettingReducers,
  DocSetting: saveDockSettingReducers,
  saveGetBoxVolumeSetting: BoxVolumeSettingReducers,
  MapDockList: GetMapDockListReducers,
  session: sessionReducers,
  SKUList: getSkuReducers,
  assignBox: AssignBoxReducers,
  CancelSession: CancelSessionReducers,
  ForcedClosed: ForceCloseReducers,
  CreatePlan: CreatePlanReducers,
  Sorter_session: ActiveSorterSessionReducers,
  SKUWiseSortPlan: GetSkuWiseSortationPlanReducers,
  RejectionText: GetRejectionDataReducers,
  BoxType: AddBoxTypeReducers,
  ActiveSession: getActiveSessionReducers,
  sessionDetail: getSessionDetailReducers,
  SaveGetInventoryIncoming: saveGetInventoryIncomingReducers,
  SubLocation: getSubLocationByInvoiceReducers,
  DeleteDock: deleteDockMapReducers,
  BoxMove: BoxMoveReducers,
  SaveProductVolume: AddProductVolumeReducers,
  BoxLabelBulkPdf: BoxPDFBulkLabelReducers,
  PrintAssociatedBoxLabelBulk: printAssociatedBoxLabelReducers,
  AssociatedBox: getDockAssociatedBoxReducers,
  AssociatedDockLabel: getDockAssociatedBoxLabelReducers,
  SaveAssociatedSetting: SaveAssociatedBoxSettingReducers,
  AssociatedSetting: getAssociatedDockSettingReducers,
  CreateSessionDyn: CreateSessionReducers,
  RemoveSession: RemoveSessionReducers,
  BoxBulkCreate: BoxCreateBulkReducers,
  BoxListData: getBoxListReducers,
  BoxLable: getBoxLableReducers
});

export default rootReducer;
